<template>
    
<svg :width="width" :height="height" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.5 4.3125C6.1925 4.3125 5.9375 4.0575 5.9375 3.75V1.5C5.9375 1.1925 6.1925 0.9375 6.5 0.9375C6.8075 0.9375 7.0625 1.1925 7.0625 1.5V3.75C7.0625 4.0575 6.8075 4.3125 6.5 4.3125Z" fill="#7B7E8C"/>
<path d="M12.5 4.3125C12.1925 4.3125 11.9375 4.0575 11.9375 3.75V1.5C11.9375 1.1925 12.1925 0.9375 12.5 0.9375C12.8075 0.9375 13.0625 1.1925 13.0625 1.5V3.75C13.0625 4.0575 12.8075 4.3125 12.5 4.3125Z" fill="#7B7E8C"/>
<path d="M12.5 17.0625H6.5C3.7625 17.0625 2.1875 15.4875 2.1875 12.75V6.375C2.1875 3.6375 3.7625 2.0625 6.5 2.0625H12.5C15.2375 2.0625 16.8125 3.6375 16.8125 6.375V12.75C16.8125 15.4875 15.2375 17.0625 12.5 17.0625ZM6.5 3.1875C4.355 3.1875 3.3125 4.23 3.3125 6.375V12.75C3.3125 14.895 4.355 15.9375 6.5 15.9375H12.5C14.645 15.9375 15.6875 14.895 15.6875 12.75V6.375C15.6875 4.23 14.645 3.1875 12.5 3.1875H6.5Z" fill="#7B7E8C"/>
<path d="M12.5 8.8125H6.5C6.1925 8.8125 5.9375 8.5575 5.9375 8.25C5.9375 7.9425 6.1925 7.6875 6.5 7.6875H12.5C12.8075 7.6875 13.0625 7.9425 13.0625 8.25C13.0625 8.5575 12.8075 8.8125 12.5 8.8125Z" fill="#7B7E8C"/>
<path d="M9.5 12.5625H6.5C6.1925 12.5625 5.9375 12.3075 5.9375 12C5.9375 11.6925 6.1925 11.4375 6.5 11.4375H9.5C9.8075 11.4375 10.0625 11.6925 10.0625 12C10.0625 12.3075 9.8075 12.5625 9.5 12.5625Z" fill="#7B7E8C"/>
</svg>

</template>

<script>
export default {
  name: "NoteIcon",
  props: {
    width: {
      type: Number,
      default: 26,
    },
    height: {
      type: Number,
      default: 26,
    },
    fill: {
      type: String,
      default: "#36373F",
    },
  },
};
</script>
